import styled from 'styled-components'

export const Container = styled.div`
    height: 100vh;

`

export const Header = styled.header`
    display:flex ;
    align-items:center;
    padding-left: 32px;
    height:64px;
    color: var(--white-zero);
    background:var(--primary-zero);
    font-family: "Poppins", sans-serif;
    font-size:12px ;
`

export const Main = styled.main`
    padding-top: 32px;
`